// extracted by mini-css-extract-plugin
module.exports = {"HomePage":"BlogPage-module--HomePage--2bqwY","subscribeWrapper":"BlogPage-module--subscribeWrapper--17xZh"};